<h2 class="modal-title">Search files</h2>

<form class="search-form" (submit)="$event.preventDefault()">
  <label class="search-label" for="navbar-search-input">Start typing to find a file</label>
  <div class="search-input-group">
    <i class="fas fa-search"></i>
    <input id="navbar-search-input" class="form-control" type="text" placeholder="Describe what you're looking for..."
      [formControl]="searchControl" autocomplete="off" autofocus>
    @if ((searchControl.value ?? '').length) {
    <button type="button" class="btn btn-link text-decoration-none" (click)="clearSearch()" aria-label="Clear search">
      <i class="fas fa-times"></i>
    </button>
    }
  </div>
</form>

@if (loading$ | async) {
<div class="status">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <span>Searching files…</span>
</div>
}

@if ((error$ | async); as error) {
<div class="status text-danger">
  <i class="fas fa-circle-exclamation"></i>
  <span>{{ error }}</span>
</div>
}

@if ((results$ | async); as results) {
<div class="results">
  @if (results.length) {
  @for (result of results; track result) {
  <button type="button" class="result" (click)="onResultClick(result)">
    <!-- File Results -->
    @if (isFileResult(result)) {
    @if (isImageFile(result.extension) && getThumbnailUrl(result); as thumbnailUrl$) {
    @if (thumbnailUrl$ | async; as thumbnailUrl) {
      <div class="thumbnail">
        <img [src]="thumbnailUrl" alt="File thumbnail">
      </div>
    } @else {
      <div class="thumbnail placeholder thumbnail-loading" data-testid="thumbnail-loading"
        role="status" aria-label="Loading file thumbnail">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span class="visually-hidden">Loading thumbnail...</span>
      </div>
    }
    } @else {
    <div class="thumbnail placeholder">
      <i class="fas {{ getFileIcon(result.extension) }}"></i>
    </div>
    }
    <div class="details">
      <span class="name">{{ result.filename }}</span>
      <span class="meta">
        {{ result.assetTypeName }} · {{ result.assetName }}
        @if (result.matchType === 'semantic') {
        <span class="match-badge">AI Match</span>
        }
      </span>
      @if (result.aiDescription) {
      <span class="description">{{ result.aiDescription }}</span>
      }
    </div>
    }
    <!-- Asset Results (backward compatibility) -->
    @if (!isFileResult(result)) {
    @if (getThumbnailUrl(result); as thumbnailUrl$) {
    @if (thumbnailUrl$ | async; as thumbnailUrl) {
      <div class="thumbnail">
        <img [src]="thumbnailUrl" alt="Asset thumbnail">
      </div>
    } @else {
      <div class="thumbnail placeholder thumbnail-loading" data-testid="thumbnail-loading"
        role="status" aria-label="Loading asset thumbnail">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span class="visually-hidden">Loading thumbnail...</span>
      </div>
    }
    } @else {
    <div class="thumbnail placeholder">
      <i class="fas fa-cube"></i>
    </div>
    }
    <div class="details">
      <span class="name">{{ result.name }}</span>
      <span class="meta">{{ result.assetTypeName }} · #{{ result.id }}</span>
    </div>
    }
  </button>
  }
  } @else {
  <div class="status muted">
    <i class="fas fa-info-circle"></i>
    <span>No files found. Try a different search.</span>
  </div>
  }
</div>
}


<div class="actions">
  <button type="button" class="btn btn-outline-secondary" (click)="close()">Close</button>
</div>

<!-- File Details Panel -->
@if (showFileDetailsPanel && (selectedFileId || selectedS3Id)) {
<app-file-details-panel [fileId]="selectedFileId" [s3Id]="selectedS3Id" [assetId]="selectedAssetId"
  [searchObservation]="selectedSearchObservation" [previewUrl]="selectedPreviewUrl" (closed)="onFileDetailsPanelClosed()">
</app-file-details-panel>
}
